<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">Production: Batch Line</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-scan-barcode
                                v-if="hasPerm('batch.read')"
                                ref="scan_barcode"
                                scan-object="work_orders_batch"
                                header-text="Batch Lookup"
                                @scanned="routeFromBarcode($event)"
                                scan-label="i"
                                :global="true"
                            ></bc-scan-barcode>
                            <bc-btn-refresh
                                @invoke-method="
                                    startLoader(),
                                        $nextTick(() => {
                                            refresh();
                                            finishLoader(true);
                                        })
                                "
                            ></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'pa-0' : 'py-0'">
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12 align-self-start pt-3>
                            <v-layout row class="mb-3">
                                <v-flex xs12>
                                    <div class="d-grid">
                                        <div>
                                            <v-btn
                                                dark
                                                class="ma-0"
                                                style="border-radius: 2px 0px 0px 2px; min-width: 45px !important"
                                                @click="changeDateRange('prev')"
                                            >
                                                <v-icon>chevron_left</v-icon>
                                            </v-btn>
                                            <v-btn
                                                dark
                                                class="ma-0"
                                                style="border-radius: 0px 2px 2px 0px; min-width: 45px !important"
                                                @click="changeDateRange('next')"
                                            >
                                                <v-icon>chevron_right</v-icon>
                                            </v-btn>
                                            <v-btn class="ml-2 ma-0" dark style="text-transform: capitalize" @click="changeDateRange('today')">Today</v-btn>
                                            <v-btn class="ml-2 ma-0" dark style="text-transform: capitalize" @click="openDateSelect()">Select Date</v-btn>
                                        </div>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <!-- <bc-charts chart-type="gantt" :chart-data="true"></bc-charts> -->
                            <div id="dpproduction" ref="scheduler"></div>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>

            <bc-dialog :value="schedule_dialog">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ show_add ? "Schedule Work Order" : "Select Work Order" }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeScheduleDialog"
                            :dialog-status="schedule_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="orders">
                            <v-container grid-list-form>
                                <v-layout row wrap v-if="show_add">
                                    <v-flex class="pa-1">{{ current_order.name }}</v-flex>
                                    <v-flex class="pa-1">{{ `Qty: ${current_order.qty}` }}</v-flex>
                                    <v-flex class="pa-1">{{ current_order.company }}</v-flex>
                                    <v-flex class="pa-1">{{ `Received on ${current_order.date_received}` }}</v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-date-picker v-model="start_date" label="Start Date" @update="start_date = $event"></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-time-picker v-model="start_time" label="Start Time" @update="start_time = $event"></bc-time-picker>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-date-picker v-model="end_date" label="End Date" @update="end_date = $event"></bc-date-picker>
                                    </v-flex>
                                    <v-flex xs12 sm6>
                                        <bc-time-picker v-model="end_time" label="End Time" @update="end_time = $event"></bc-time-picker>
                                    </v-flex>
                                    <v-flex xs12>
                                        <bc-autocomplete label="Machine *" :items="machines || []"></bc-autocomplete>
                                    </v-flex>
                                    <v-flex xs12>
                                        <v-textarea label="Notes" auto-grow rows="1"></v-textarea>
                                    </v-flex>
                                </v-layout>
                                <vue-perfect-scrollbar v-else class="scroll-area" :style="$bp.xs ? null : 'max-height: calc(100vh - 150px)'">
                                    <v-list two-line class="dropdown-list">
                                        <template v-for="(order, index) in unscheduled_work_orders">
                                            <div :key="index" v-if="index < 5">
                                                <v-divider v-if="index > 0" class="ma-0 grey lighten-1"></v-divider>
                                                <v-list-tile
                                                    v-ripple
                                                    class="clickable text-xs-center headline"
                                                    :class="{ 'list-hover': !$bp.smallScreen }"
                                                    @click="setCurrentOrder(order)"
                                                >
                                                    <v-list-tile-content>
                                                        <v-list-tile-title
                                                            v-html="'Batch ' + (index + 1) + ': ' + order.name"
                                                            class="fw-bold"
                                                        ></v-list-tile-title>
                                                        <v-list-tile-sub-title
                                                            v-html="'Recieved: ' + order.date_received + ' from ' + order.company + ' ' + ''"
                                                        ></v-list-tile-sub-title>
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </div>
                                        </template>
                                    </v-list>
                                </vue-perfect-scrollbar>
                            </v-container>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn v-if="show_add" color="secondary" @mouseup.left="show_add = false">Go Back</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeScheduleDialog()">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn v-if="show_add" color="success">Add To Schedule</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <bc-dialog :value="part_process_error_dialog">
                <v-card>
                    <v-card-title class="red-dialog-title">
                        <span class="headline">Incomplete Process</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="part_process_error_dialog"
                            :dialog-status="part_process_error_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs12
                                    >This part has a process that is not properly set up. To schedule this part please visit the part profile and complete the
                                    process.</v-flex
                                >
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="part_process_error_dialog = false">{{ $t("lang.cancel") }}</v-btn>
                        <v-btn
                            v-if="part_with_error"
                            color="primary"
                            @mouseup.left="$router.push({ name: 'part_profile', params: { id: part_with_error.part_id, tab: 'process' } })"
                            >Go to part</v-btn
                        >
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <v-dialog ref="dialog" v-model="select_date_dialog" :return-value="select_date" persistent lazy full-width width="290px">
                <v-date-picker v-model="select_date" scrollable>
                    <v-spacer></v-spacer>
                    <v-btn flat color="primary" @click="select_date_dialog = false">Cancel</v-btn>
                    <v-btn
                        color="primary"
                        :disabled="$route.query.start_date ? convertTimestampToDate($route.query.start_date) == select_date : false"
                        @click="customButtonAction('gotoDate')"
                    >
                        OK
                    </v-btn>
                </v-date-picker>
            </v-dialog>
            <bc-dialog v-if="calendar_event_dialog" :value="calendar_event_dialog" max-width="800">
                <v-card>
                    <v-card-title>
                        <span class="headline" v-if="current_event"
                            >{{ current_event.start }}
                            -
                            {{ current_event.end }}</span
                        >
                        <span class="headline" v-else>Not Scheduled</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            dialog-model="calendar_event_dialog"
                            :dialog-status="calendar_event_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <v-layout row wrap class="pb-3 px-2">
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.part_name") }}</span>
                                <h3>{{ current_event_props.name ? current_event_props.name : "---" }}</h3>
                            </v-flex>
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.customer_part_number") }}</span>
                                <h3>{{ current_event_props.customer_part_number ? current_event_props.customer_part_number : "---" }}</h3>
                            </v-flex>
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.company") }}</span>
                                <h3>{{ current_event_props.company ? current_event_props.company : "---" }}</h3>
                            </v-flex>
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.batch_qty") }}</span>
                                <h3>{{ current_event_props.batch_qty ? current_event_props.batch_qty + " Qty" : "---" }}</h3>
                            </v-flex>
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.pattern_number") }}</span>
                                <h3>{{ current_event_props.pattern_number ? current_event_props.pattern_number : "---" }}</h3>
                            </v-flex>
                            <v-flex xs6 align-self-start>
                                <span class="fs-14">{{ $t("lang.batch_count") }}</span>
                                <h3>
                                    {{
                                        current_event_props.batch_count
                                            ? current_event_props.batch_count + (current_event_props.batch_count == "1" ? " Batch" : " Batches")
                                            : "---"
                                    }}
                                </h3>
                            </v-flex>
                        </v-layout>
                        <v-layout
                            row
                            class="border-bottom-2"
                            :style="!$bp.smallScreen ? 'max-height: 525px;' : ''"
                            v-if="current_event_props.work_orders_batches"
                        >
                            <v-flex xs12 pa-0 :style="!$bp.smallScreen ? 'overflow: auto' : ''">
                                <v-data-table
                                    :headers="batch_headers"
                                    :items="current_event_props.work_orders_batches"
                                    item-key="batch_id"
                                    :no-data-text="$t('lang.no_results_matching')"
                                    hide-actions
                                >
                                    <template slot="items" slot-scope="props">
                                        <tr class="clickable" @mouseup.left="goToBatch(props.item)">
                                            <td class="px-1 text-center">{{ props.item.batch_control_id }}</td>
                                            <td class="px-1 text-center">{{ props.item.batch_size ? props.item.batch_size : "" }}</td>
                                            <td class="px-1 text-center">{{ props.item.start }}</td>
                                            <td class="px-1 text-center">{{ props.item.current_station }}</td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            color="error"
                            @mouseup.left="$refs.unscheduleDialog.openDialog()"
                            v-if="current_event && current_event_props.has_completed_furnace == '0' && hasPerm('scheduling.delete')"
                            >Unschedule</v-btn
                        >
                        <v-btn color="error" @mouseup.left="$refs.deleteDialog.openDialog()" v-else-if="!current_event && hasPerm('scheduling.delete')"
                            >Delete</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn v-if="current_event" color="primary" @mouseup.left="dev_mode ? showPrinter('print_4x6_label') : printLabel('print_4x6_label')">
                            {{ $t("lang.print_label") }}
                        </v-btn>
                        <v-btn
                            v-if="current_event"
                            color="primary"
                            @mouseup.left="dev_mode ? showPrinter('print_process_sheet') : printLabel('print_process_sheet')"
                        >
                            {{ $t("lang.print_process_sheet") }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
            <delete-confirmation-dialog
                ref="unscheduleDialog"
                :headline="$t('lang.unschedule')"
                :message="$t('lang.confirm_unschedule_header')"
                @onConfirm="onUnscheduleConfirm"
            ></delete-confirmation-dialog>
            <bc-modal-print ref="print" @close-method="(file_name = null), $refs.print.close()" :file-name="file_name" :no-button="true"></bc-modal-print>
        </v-container>
    </div>
</template>

<script>
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import { toMoment } from "@fullcalendar/moment"; // only for formatting
import momentTimezonePlugin from "@fullcalendar/moment-timezone";
import { mapActions, mapGetters, mapState } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";
import { DayPilot, DayPilotScheduler } from "daypilot-pro-vue";

export default {
    components: {
        DayPilotScheduler,
    },
    data() {
        return {
            start_time: null,
            start_date: null,
            end_time: null,
            end_date: null,
            current_order: null,
            schedule_dialog: false,
            show_add: false,
            search_date: null,
            line_view: "batch",
            headers: [
                { text: this.$t("lang.production_line"), sortable: false, width: "33%" },
                { text: this.$t("lang.machine_name"), sortable: false, width: "33%" },
                { text: this.$t("lang.short_code"), sortable: false, width: "33%" },
            ],
            warehouse_headers: [
                { text: "", sortable: false, width: "5%" },
                { text: this.$t("lang.aged"), value: "days_aged", width: "10%", align: "center" },
                { text: this.$t("lang.customer"), value: "company", width: "25%" },
                { text: this.$t("lang.part_number_short"), value: "customer_part_number", width: "15%" },
                { text: this.$t("lang.part_name"), value: "name", width: "30%" },
                { text: this.$t("lang.warehouse_qty"), value: "warehouse_qty", width: "15%", align: "center" },
                // { text: '', sortable: false, width: '15%' },
            ],
            batch_headers: [
                { text: this.$t("lang.control_id"), value: "batch_control_id", align: "center" },
                { text: this.$t("lang.qty"), value: "batch_size", align: "center" },
                { text: this.$t("lang.start"), value: "start", align: "center" },
                { text: this.$t("lang.current_station"), value: "current_station", align: "center" },
            ],
            warehouse_default_sort: {
                descending: true,
                sortBy: "days_aged",
                rowsPerPage: -1,
            },
            machine: {
                line_id: "",
                machine_name: "",
                short_code: "",
            },
            current_obj: null,
            filter: {
                search: "",
                line_id: "",
                page_size: 0,
                page_num: 0,
            },
            machine_dialog: false,
            mobile_list: [
                { title: this.$t("lang.add_new"), action: "showMachine" },
                { title: this.$t("lang.refresh"), action: "dbGetMachines" },
            ],
            scanned_schedule: [],
            current_part: null,
            back_to_warehouse: true,
            warehouse_dialog: false,
            part_process_error_dialog: false,
            part_with_error: null,
            selected_wo: [],
            schedule_qty: [],
            scanned_qty: [],
            select_date_dialog: false,
            select_date: null,
            update_unscheduled: 0,
            scanned_schedule: [],
            settings: {
                suppressScrollX: true,
            },
            schedulerChart: null,
            calendar_event_dialog: false,
            current_event: null,
            current_event_props: {
                work_orders_batches: [],
            },
            current_part: null,
            file_name: null,
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.startLoader();
            vm.$store.commit("toggleMainMenu", false);
            vm.$router.push({ query: { start_date: Math.floor(new Date() / 1000), end_date: Math.floor(new Date() / 1000 + 86400) } });
            vm.finishLoader();
        });
        // let parsedQuery = JSON.parse(JSON.stringify(to.query));
        // store.dispatch(
        //     "fetchMachines",
        //     {
        //         url: 'machines',
        //         method: 'get',
        //         stateProperty: 'machines',
        //         commit: true,
        //         body: parsedQuery
        //     }
        // ).then((data) => {
        //     if (typeof(data) !== 'undefined' && data.machines)
        //     {
        //         next(vm => {
        //             vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
        //             vm.finishLoader();
        //         })
        //     }else{
        //         next({ name: 'dashboard', replace: true });
        //     }
        // })
        // next((vm) => {
        //     vm.search_date = vm.current_day;
        //     vm.finishLoader();
        // });
    },
    beforeRouteUpdate(to, from, next) {
        // let parsedQuery = JSON.parse(JSON.stringify(to.query));
        // this.$store.dispatch(
        //     "fetchMachines",
        //     {
        //         url: 'machines',
        //         method: 'get',
        //         stateProperty: 'machines',
        //         commit: true,
        //         body: parsedQuery
        //     }
        // ).then((data) => {
        //     if (typeof(data) !== 'undefined' && data.machines)
        //     {
        //         this.setQuery(parsedQuery, this.filter, this.default_filter);
        //         this.finishLoader();
        //         next()
        //     }else{
        //         next({ name: 'dashboard', replace: true });
        //     }
        // })
        this.search_date = this.current_day;
        next(this.finishLoader());
    },
    computed: {
        ...mapState({
            warehouse: (state) => state.work_orders.warehouse,
            machines: (state) => state.machines.machines,
            production_lines: (state) => state.production.production_lines,
            unscheduled_work_orders: (state) => state.work_orders.unscheduled_work_orders,
            schedule: (state) => state.work_orders.schedule,
            machines: (state) => state.machines.machines,
        }),
        total_qty() {
            return _.sumBy(this.schedule_qty || [], (qty) => +qty);
        },
        total_batches() {
            let total = 0;
            if (this.current_part && !!(+this.total_qty / +this.current_part.batch_size)) {
                total = Math.ceil((+this.total_qty / +this.current_part.batch_size) * 1000) / 1000;
            }
            return Math.max(total, 0);
        },
        partial_batch() {
            if (!this.current_part || !this.total_qty) return 0;
            return Math.ceil((this.total_batches * 1000) % 1000) / 10;
        },
    },
    methods: {
        ...mapActions(["saveBatchToSchedule", "fetchBatchSchedule", "removeBatchFromSchedule", "fetchBatchProductionSchedule"]),
        setCurrentOrder(order) {
            this.current_order = order;
            this.show_add = true;
        },
        closeScheduleDialog() {
            this.schedule_dialog = false;
            this.show_add = false;
        },
        getWarehouse(status = true) {
            if (status) {
                this.$store.commit("toggleModalLoader", true);
                this.warehouse_dialog = true;
                this.back_to_warehouse = true;
            }
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: "warehouse?line_id=1",
                    method: "get",
                    stateProperty: "warehouse",
                    commit: true,
                })
                .then((data) => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        closeWarehouseDialog() {
            this.warehouse_dialog = false;
            this.current_part = null;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
            this.scanned_schedule = [];
            this.scanned_qty = [];
        },
        openPartErrorDialog(part) {
            this.part_with_error = part;
            this.part_process_error_dialog = true;
        },
        setScheduleValue(qty, index) {
            this.$set(this.schedule_qty, index, qty);
        },
        setFromScan(scan) {
            let found_scan = null;
            if (scan && scan.receiving_id) {
                found_scan = this.schedule.filter((w) => w.receiving_id == scan.receiving_id)[0];
                if (found_scan && this.scanned_schedule.filter((s) => s.receiving_id == scan.receiving_id).length == 0) {
                    this.scanned_schedule.push(found_scan);
                    this.scanned_qty.push(+found_scan.warehouse_qty);
                } else {
                    found_scan = null;
                }
            }
            if (!found_scan) {
                this.createAlert("error", "scan_again");
            }
            this.$refs.scan_barcode.resetBarcode();
        },
        openDateSelect() {
            this.select_date_dialog = true;
        },
        customButtonAction(action) {
            this.select_date_dialog = false;
            let one_day = 60 * 60 * 24;
            let new_start_date = new Date(this.select_date).getTime() / 1000;
            let chart_start_date = new Date(new_start_date * 1000);

            this.$nextTick(() => {
                this.$router.push({
                    name: this.$route.name,
                    query: {
                        start_date: new_start_date,
                        end_date: new_start_date + one_day,
                    },
                    params: {
                        loader: false,
                    },
                });
                this.schedulerChart.update({ startDate: new DayPilot.Date(chart_start_date), days: 2 });
                this.getBatchSchedule();
                // udpate date picker if other button is used
            });
        },
        convertDateToTimestamp(date) {
            let new_date = new Date(
                new Date(date).toLocaleDateString("fr-CA", { timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York" })
            ).setHours(0, 0, 0, 0);
            return new_date / 1000;
        },
        convertTimestampToDate(timestamp) {
            return new Date(timestamp * 1000).toLocaleDateString("fr-CA", {
                timeZone: this.current_user ? this.current_user.user_time_zone : "America/New_York",
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
            });
        },
        scheduleBatch() {
            // alert('schedule')
            if (this.validateForm("schedule")) {
                let batches = [];
                this.schedule.forEach((s, i) => {
                    // only send if a qty is entered
                    if (!!this.schedule_qty[i] && +this.schedule_qty[i] > 0) {
                        batches.push({
                            receiving_id: s.receiving_id,
                            batch_qty: this.schedule_qty[i],
                        });
                    }
                });

                let schedule_obj = {
                    company_id: this.current_part.company_id,
                    part_id: this.current_part.part_id,
                    part_station_id: this.station_options,
                    batches: batches,
                };
                this.$store.commit("toggleModalLoader", true);
                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: "work_orders",
                        method: "post",
                        stateProperty: "work_orders_batches",
                        mutate: true,
                        body: schedule_obj,
                    })
                    .then((data) => {
                        if (data && data.code == "200") {
                            if (+this.current_part.warehouse_qty - this.total_qty > 0) {
                                this.$store.commit("mutateWorkOrder", {
                                    property: "warehouse",
                                    method: "patch",
                                    id: data.work_orders_batches[0].part_id,
                                    pk: "part_id",
                                    with: {
                                        part_id: data.work_orders_batches[0].part_id,
                                        warehouse_qty: (+this.current_part.warehouse_qty - this.total_qty).toString(),
                                        batched_qty: (+this.current_part.batched_qty + this.total_qty).toString(),
                                    },
                                });
                            } else if (+this.current_part.warehouse_qty - this.total_qty == 0) {
                                this.$store.commit("mutateWorkOrder", {
                                    property: "warehouse",
                                    method: "delete",
                                    id: data.work_orders_batches.part_id,
                                    pk: "part_id",
                                });
                            }
                            this.scanned_schedule = [];
                            this.scanned_qty = [];
                            this.warehouse_dialog = false;
                            this.confirm_schedule_dialog = false;
                            setTimeout(() => {
                                this.current_part = null;
                            }, 300);
                        }
                        this.$store.commit("toggleModalLoader", false);
                    });
            }
        },
        prepOrderForDrag(order) {
            return JSON.stringify(order);
        },
        makeDraggable() {
            var items = document.querySelectorAll(".draggable-event");
            for (var i = 0; i < items.length; i++) {
                var e = items[i];
                var item = {
                    element: e,
                    data: JSON.parse(e.getAttribute("data-event")),
                    id: e.getAttribute("data-id"),
                    keepElement: true,
                };
                DayPilot.Scheduler.makeDraggable(item);
            }
        },
        changeDateRange(direction) {
            let start_date = this.$route.query.start_date;
            let end_date = this.$route.query.end_date;
            let chart_start_date = null;
            let chart_end_date = null;
            if (direction == "next") {
                // add a full day to the start date timestamp
                start_date = +start_date + 86400;
                end_date = +end_date + 86400;
                chart_start_date = new Date(start_date * 1000);
                chart_end_date = new Date(end_date * 1000);
            } else if (direction == "prev") {
                start_date = +start_date - 86400;
                end_date = +end_date - 86400;
                chart_start_date = new Date(start_date * 1000);
                chart_end_date = new Date(end_date * 1000);
            } else if (direction == "today") {
                start_date = Math.floor(new Date() / 1000);
                end_date = start_date + 86400;
                chart_start_date = new Date(start_date * 1000);
                chart_end_date = new Date(end_date * 1000);
            }

            this.schedulerChart.update({
                startDate: new DayPilot.Date(start_date * 1000),
                days: 2,
            });
            this.$router.push({
                name: this.$route.name,
                query: {
                    start_date: start_date,
                    end_date: end_date,
                },
            });
            this.getBatchSchedule();
        },
        handleEventClick(info) {
            this.calendar_event_dialog = true;
            this.current_event = info;
            this.current_event_props = info;
            this.current_event_props.work_orders_batches = info.work_orders_batches || [];
        },
        openUnscheduled(event) {
            this.current_event_props = event;
            this.current_event = null;
            this.calendar_event_dialog = true;
        },
        goToBatch(batch) {
            this.$router.push({ name: "batch_line_profile", params: { work_order_id: batch.work_order_id, batch_id: batch.batch_id } });
        },
        onUnscheduleConfirm() {
            this.$store.commit("toggleModalLoader", true);

            this.removeBatchFromSchedule({ work_order_id: this.current_event.work_order_id }).then((data) => {
                if (data && data.code == "200") {
                    this.$refs.unscheduleDialog.close();
                    this.calendar_event_dialog = false;
                    this.getBatchSchedule();
                }
                this.$store.commit("toggleModalLoader", false);
            });
        },
        showPrinter(type) {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/batch/${this.current_event.work_order_id}/${type}`,
                    method: "get",
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.process_sheet) {
                        this.file_name = data.process_sheet.file_name;
                    } else if (typeof data != "undefined" && data.bill_of_lading) {
                        this.file_name = data.bill_of_lading.file_name;
                    } else {
                        this.file_name = "";
                        this.$refs.print.close();
                        this.createAlert();
                    }
                });
        },
        printLabel(type) {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/batch/${this.current_event.work_order_id}/${type}`,
                    method: "get",
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.process_sheet) {
                        this.$refs.print.printReport(data.process_sheet.file_name);
                    } else if (typeof data != "undefined" && data.bill_of_lading) {
                        this.$refs.print.printReport(data.bill_of_lading.file_name);
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        getBatchSchedule() {
            this.fetchBatchProductionSchedule({ body: { start_date: this.$route.query.start_date, end_date: this.$route.query.end_date } }).then((data) => {
                if (data && data.work_orders_batches) {
                    this.schedulerChart.events.list = [];
                    data.work_orders_batches.forEach((batch) => {
                        this.schedulerChart.events.add({
                            id: DayPilot.guid(),
                            start: new DayPilot.Date(new Date(batch.start.replace(" ", "T") + ":00"), true),
                            end: new DayPilot.Date(new Date(batch.end.replace(" ", "T") + ":00"), true),
                            resource: batch.resource,
                            data: batch,
                            work_order_id: batch.work_order_id,
                            backColor: batch.color,
                            fontColor: "#ffffff",
                            barHidden: true,
                            html: `<v-layout row wrap>
											<v-flex column xs10 pt-1 pl-2>
												<span>${new Date(batch.start).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: false })} - ${new Date(batch.end).toLocaleTimeString(
                                "en-US",
                                { hour: "2-digit", minute: "2-digit", hour12: false }
                            )}</span>
												</br>
												<span>${batch.batch_control_id}</span>
												</br>
												<span>${batch.name}</span>
												</br>
												<span>${batch.customer_part_number}</span>
												</br>
												<span>Qty ${batch.batch_size}</span>
												</br>
												<span>${batch.current_station}</span>
											</v-flex>
										</v-layout>
										`,
                        });
                    });
                    this.schedulerChart.update();
                }
            });
        },
        routeFromBarcode(barcode) {
            this.$router.push({ name: "batch_line_profile", params: { work_order_id: barcode.work_order_id, batch_id: barcode.batch_id } });
        },
        async refresh(force = false) {
            // this.fetchScheduledBatches({ start_date: this.$route.query.start_date, end_date: this.$route.query.end_date });
            let dis = this;
            if (this.schedulerChart == null) {
                this.schedulerChart = new DayPilot.Scheduler("dpproduction", {
                    timeHeaders: [
                        { groupBy: "Day", format: "dddd, yyyy-MM-dd" },
                        { groupBy: "Hour", format: "H" },
                        { groupBy: "Cell", format: "mm" },
                    ],
                    scale: "CellDuration",
                    cellDuration: 30,
                    days: 2,
                    startDate: DayPilot.Date.today(),
                    timeRangeSelectedHandling: "Disabled",
                    eventResizeHandling: "Disabled",
                    resources: [],
                    events: [],
                    cellWidthSpec: "Fixed",
                    cellWidth: 28,
                    rowMinHeight: 88,
                    eventHeight: 88,
                    height: 650,
                    eventMoveHandling: "Disabled",
                    onEventClick: (args) => {
                        dis.goToBatch(args.e.data.data);
                    },
                    onBeforeEventRender: (args) => {
                        if (args.e.data.qc_flag == 1) {
                            args.data.areas = [
                                {
                                    right: 5,
                                    top: 5,
                                    width: 16,
                                    height: 16,
                                    style: "fill: #fff",
                                    html: '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="#ffffff" d="M12.09 3.24c-3.61-1.84-6.52-.78-8.01.38 -.22.16-.49.37-.67.74 -.19.36-.18.72-.18 1.05l-.01 15.32c0 .55.44 1 1 1 .55 0 1-.45 1-1v-5.8c0-.16 0-.24.03-.31s.1-.11.22-.19c1.21-.72 3.29-1.23 5.89.1 3.71 1.89 6.92 1.12 8.51.26 .15-.09.46-.26.64-.56 .18-.31.17-.7.17-.89V5.77c0-.38 0-.73-.03-1 -.03-.24-.1-.68-.47-.96 -.21-.16-.44-.21-.61-.22 -.18-.02-.35.01-.5.03 -.3.05-.71.16-1.14.28 -1.42.39-3.52.47-5.93-.76Z"/></svg>',
                                },
                            ];
                        }
                    },
                });

                this.schedulerChart.init();
            }

            this.$store
                .dispatch("fetchMachines", {
                    url: "machines",
                    method: "get",
                    stateProperty: "machines",
                    commit: true,
                    body: JSON.parse(JSON.stringify({ resource: 1, line_id: 1 })),
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.machines) {
                        this.schedulerChart.update({ resources: data.machines });
                    }
                });
            // Scroll to the current date and current time
            this.schedulerChart.scrollTo(new DayPilot.Date());

            this.getBatchSchedule();
        },
    },
    mounted() {
        this.refresh();
    },
};
</script>
<style>
.scheduler_default_event {
    font-size: 0.85em;
}
</style>
